<cm-header class="header" [settings]="menuSettings"></cm-header>
<div class="page-content"><router-outlet></router-outlet></div>

<ng-template #notificationMessage let-id="id" let-context="context">
    <div class="message-notification">
        <span class="remove-btn" (click)="removeNotificationMessage({ id: id, messageId: context.id })"></span>
        <div
            class="bell-icon"
            [ngClass]="{
                orange: context.statusColorId === STEP_COLOR_STATUSES.ORANGE,
                red: context.statusColorId === STEP_COLOR_STATUSES.RED
            }"
        ></div>
        <div class="content">
            <div class="text">
                Your Step "{{ context.name }}" is nearing its due date. You may use our Opportunities to complete it
            </div>
            <div class="opportunities-link">
                <div class="cm-link bold" (click)="onSeeOpportunities($event, context.id)">SEE OPPORTUNITIES</div>
            </div>
        </div>
    </div>
</ng-template>
